export const parseHTML = (HTMLString, isCSV = false) => {
	if (!isCSV) return HTMLString;
	const replacements = new Map([
		[
			/(<sup>)(\s*\d*\s*)(<\/sup>)/gi,
			(match, p1, p2, p3, offset, string) => {
				return [...p2].map((n) => ['⁰', '¹', '²', '³', '⁴', '⁵', '⁶', '⁷', '⁸', '⁹'][Number(n)]).join('');
			},
		],
		[/(<([^>]+)>)/gi, ''],
	]);

	replacements.forEach((value, key) => (HTMLString = HTMLString.trim().replace(key, value)));
	return HTMLString;
};
